<div class="container px-4">
  <div class="row mt-5 d-flex justify-content-center align-items-center">
<!--    <div class="col-7 col-l-6 col-xl-5 col-xxl-4">-->
    <div class="col-10 col-md-8 col-lg-7 col-xl-4">

      <baxter-auth
        [application]="'LIMIT_MANAGER'"
        [backgroundColor]="'green'"
        [toastrService]="toastrService"
        [fontColor]="'black'"
        [headerLabelFontColor]="'white'"
        [usernameInputClasses]="'textInputColor'"
        [passwordInputClasses]="'form-control textInputColor'"
        [emailInputClasses]=""
        (successLogin)="successLogin()"
        [cardClasses]="'bg-dark'"
        [cardBodyClasses]="'bg-dark'"
        [registerButtonClasses]="'w-100 btn btn-success '"
        [backToLoginButtonClasses]="'w-100 btn btn-success '"
        [loginButtonClasses]="'w-100 btn btn-success text-uppercase'"
        [submitForgotPasswordButtonClasses]="'w-100 btn btn-success text-uppercase'"
        [submitNewForgotPasswordButtonClasses]="'w-100 btn btn-success text-uppercase'"
        [changeToForgotPasswordButtonClasses]="'w-100 btn btn-link text-white'"
        [changeToRegisterLinkClass]="'text-white'"
        [changeToRegisterLabelClass]="'text-white'"
      ></baxter-auth>
    </div>
  </div>
</div>
<ng-template #header let-headerText="headerText">
  <div class="row mb-4">
    <div class="col-4 text-center">
      <h1>{{headerText}}</h1>
    </div>
  </div>
</ng-template>
